<script>
import {
  process_downloadTheFileEmail,
} from "@/lib/request";
import * as Reg from '@/untils/reglist'
export default {
  name: 'sendEmail',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    variablesEmailObj: {
      type: Object,
      default: {}
    },
  },
  components: {},
  data() {
    return {
      showPopup: this.value,
      submitFlag: true,
      emailName: '',
    }
  },
  computed: {},
  watch: {
    value(val) {
      this.showPopup = val;
    },
    showPopup(val) {
      this.$emit('input', val);
    },
  },
  created() {

  },
  methods: {
    cancel() {
      if (!this.submitFlag) {
        this.$toast('正在提交数据，请耐心等待');
        return false;
      }
      this.showPopup = false;
    },
    validateEmail1(value) {
      if (!Reg.mailReg.test(value)) {
        return false;
      }
    },
    validateRequired(val) {
      return !(val === null || val === undefined || val === '');
    },
    // 输入框校验
    getRules(field) {
      if (field.required) {
        const baseRules = [
          {
            validator: (val) => this.validateRequired(val, field.name),
            message: `${field.name}`
          }
        ]
        switch (field.id_name) {
          case 'email':
            return [
              ...baseRules,
              {validator: this.validateEmail1, message: '请输入正确的邮箱'},
            ]

          default:
            return baseRules
        }
      }
    },
    onSubmit() {
      if (!this.submitFlag) {
        this.$toast('正在提交数据，请耐心等待');
        return false;
      }
      this.submitFlag = false;
      if (this.variablesEmailObj.fileName.length === 0) {
        this.$toast('请选择文件');
        return false;
      }
      const nameList = this.variablesEmailObj.fileName.map(file => file.name);
      const fileName = nameList.join('，');
      let params = {
        processInstanceId: this.variablesEmailObj.processInstanceId,// ?processInstanceId=8f5f6d91-a9a1-11f0-b3b9-6270d3d46c93
        flowType: this.variablesEmailObj.flowtype,// &flowType=1
        recipient: this.emailName,// &recipient=2351979192@qq.com
        fileName: fileName,// &fileName=%E7%99%BB%E8%AE%B0%E8%A1%A8,%E5%AE%A1%E6%89%B9%E8%A1%A8
      }
      console.log(params)
      // return ;
      process_downloadTheFileEmail(params).then(res => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              this.submitFlag = true;
              this.$toast('邮件发送成功，请注意查收！');
              this.showPopup = false;
              this.$emit('submit', {});
            } else {
              this.submitFlag = true;
              this.$toast(res.data.msg);
              return false;
            }
          }
        }
      })
    },

  }
}
</script>

<template>
  <div>
    <van-popup
        v-model="showPopup"
        round
        :style="{width: '90%',height:'auto'}"
        :close-on-click-overlay="false"
        position="center">
      <div class="pop-inner">
        <div class="form-section">
          <div class="supply-items">
            <div class="supply-header">
              <div class="supply-name">文件发送至邮箱</div>
              <div class="supply-btn" @click="cancel">
                <van-icon name="cross"/>
              </div>
            </div>
            <div class="up-wrap">
              <div class="title">{{ variablesEmailObj.flowname }}</div>
              <span v-for="(item,index) in variablesEmailObj.fileName" :key="index" style="margin-right: 10px">
              <van-icon name="checked" color="#ee0a24" style="vertical-align: middle;margin-top: -4px"
                        size="23px"/> {{ item.name }}
            </span>
              <!--            <van-checkbox-group v-model="radio" style="display:flex;flex-direction: row">-->
              <!--              <van-checkbox :name="item.name" style="margin-right: 10px" checked-color="#ee0a24" v-for="(item,index) in variablesEmailObj.fileName" :key="index">{{item.name}}</van-checkbox>-->
              <!--            </van-checkbox-group>-->
              <!--            <van-radio-group v-model="radio">-->
              <!--              <van-radio :name="item.name" checked-color="#ee0a24" v-for="(item,index) in variablesEmailObj.fileName" :key="index">{{item.name}}</van-radio>-->
              <!--            </van-radio-group>-->
            </div>
            <van-form @submit="onSubmit">
              <div class="group-input-box">
                <div class="label-name">您的邮箱：</div>
                <van-field
                    v-model="emailName"
                    name="emailName"
                    placeholder="请输入您的邮箱"
                    :rules="getRules({
                    required:true,
                    name:'请输入您的邮箱',
                    id_name:'email'})"
                >
                </van-field>
              </div>
              <van-button round block type="info" class="submit-btn" :disabled="!submitFlag" native-type="submit">
                <van-loading v-if="!submitFlag" size="15px" type="spinner" text-size="15px" color="#fff"></van-loading>
                确定
              </van-button>
            </van-form>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style scoped lang="scss">

.pop-inner {
  height: 100%;
  width: 100%;
  padding: 30px 30px 50px;
  box-sizing: border-box;
}

.form-section {
  padding: 0;
}


.supply-header {
  padding: 10px 20px 20px;
  display: flex;
  justify-content: space-between;
}

.supply-name {
  display: flex;
  width: 100%;
  font-size: 38px;
  color: #2d3436;
  justify-content: center;
  margin-bottom: 10px;
}

.supply-btn {
  font-size: 42px;
  font-weight: 600;
  color: #aaaaaa;
}

.supply-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.up-wrap {
  .title {
    font-weight: bold;
    padding: 10px 10px 14px;
    box-sizing: border-box;
  }
}

.group-input-box {
  padding: 20px 10px;
  box-sizing: border-box;
  margin-bottom: 20px;

  .label-name {
    padding: 10px 0;
    box-sizing: border-box;
  }

  /deep/ .van-cell {
    padding-left: 30px;
    height: auto;
    background: transparent;
    border: 2px solid #ddd;
  }
}

.submit-btn {
  width: 50%;
  margin: 0 auto;

  /deep/ .van-loading {
    display: inline-block;
    margin-right: 10px;
    vertical-align: middle;
    margin-top: -5px;
  }
}
</style>